// Stub — no dynamic menu items from API needed
// The Navigation component expects this export

import { NavItemType } from 'types/menu';

export function MenuFromAPI(): NavItemType {
  return {
    id: 'group-dashboard',
    type: 'group',
    children: []
  };
}
